import Joi from 'joi';

import { VehicleOdometerChangeReasonEnum } from '../../../vehicle-odometer-tracking';

/**
 * Schema for validating properties required to update the odometer.
 * @description This schema validates that the odometer value is provided as a number,
 * the recorded date is a valid date not set in the future, and the change reason is valid.
 * Null values are not permitted for required fields. Additional properties beyond those
 * defined in the schema will be ignored.
 */
export const updateVehicleOdometerSchema = () =>
  Joi.object({
    value: Joi.number().min(0.00001).max(99999999).required().messages({
      'number.base':
        'validations|update-vehicle-odometer|odometer-value-must-be-number',
      'number.unsafe':
        'validations|update-vehicle-odometer|odometer-value-too-long',
      'any.required':
        'validations|update-vehicle-odometer|odometer-value-required',
      'number.max':
        'validations|update-vehicle-odometer|odometer-value-too-long',
      'number.min':
        'validations|update-vehicle-odometer|odometer-value-required',
    }),

    recordedAt: Joi.date().max('now').required().messages({
      'date.base':
        'validations|update-vehicle-odometer|recorded-at-must-be-valid',
      'date.max':
        'validations|update-vehicle-odometer|recorded-at-cannot-be-in-future',
      'any.required':
        'validations|update-vehicle-odometer|recorded-at-required',
    }),

    changeReason: Joi.alternatives()
      .try(
        Joi.string()
          .valid(...Object.values(VehicleOdometerChangeReasonEnum))
          .required()
          .messages({
            'any.only':
              'validations|update-vehicle-odometer|change-reason-invalid',
            'any.required':
              'validations|update-vehicle-odometer|change-reason-required',
            'string.base':
              'validations|update-vehicle-odometer|change-reason-required',
            'string.empty':
              'validations|update-vehicle-odometer|change-reason-required',
          }),
        Joi.any().invalid(null).messages({
          'any.invalid':
            'validations|update-vehicle-odometer|change-reason-required',
        }),
      )
      .messages({
        'alternatives.match':
          'validations|update-vehicle-odometer|change-reason-required',
      }),

    notes: Joi.string().allow(null, '').max(256),
  }).unknown(true);
